<template>
    <div>
        <v-progress-linear
            indeterminate
            height="10"
            color="cyan">
        </v-progress-linear>
    </div>
</template>

<script>
    export default {
        
    }
</script>